<template>
  <div>
    <!-- Header with Faculty and Program -->
    <div v-if="matter" class="title-presentation">
      <div class="school-title w-50">
        {{ $getVisibleNames("mesh.faculty", false, "Facultad").toUpperCase() }}:
        {{ faculty ? faculty.name.toUpperCase() : "" }}
      </div>
      <div class="program-title w-50">
        {{ $getVisibleNames("mesh.career", false, "Programa").toUpperCase() }}:
        {{ careerFilter ? careerFilter.name.toUpperCase() : "" }}
      </div>
    </div>

    <!-- Main Table Container -->
    <div
      class="table-container"
      :class="{ 'table-container-odd': !isPairNumberTableHeader }"
    >
      <!-- Nombre -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">NOMBRE</div>
        <div class="secundary-cell name-matter w-50">
          <span v-if="matter">{{
            oldMatter ? oldMatter.name.toUpperCase() : ""
          }}</span>
        </div>
      </div>

      <!-- Código -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.matter_code",
              false,
              "Código"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell code-matter w-50">
          <span v-if="matter">{{
            oldMatter ? oldMatter.code.toUpperCase() : ""
          }}</span>
        </div>
      </div>

      <!-- Codigo EPM -->
      <div
        v-if="
          institution &&
          institution.use_epm_code &&
          matter &&
          matter.code &&
          oldMatter &&
          matter.code !== oldMatter.code
        "
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.ep_matter_code",
              false,
              "Código"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell code-matter w-50">
          <span>{{ matter.code.toUpperCase() }}</span>
        </div>
      </div>

      <!-- Nivel del Plan -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">NIVEL DEL PLAN</div>
        <div class="secundary-cell w-50">
          <span v-if="matter">{{ matter.plan_level }}</span>
        </div>
      </div>

      <!-- Prerrequisitos -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">PRERREQUISITO(S)</div>
        <div class="secundary-cell w-50">
          <p v-if="prerequisites.length == 0" class="prerequisites-p">
            No tiene
          </p>
          <p v-else class="prerequisites-p">{{ prerequisites.join(", ") }}</p>
        </div>
      </div>

      <!-- Semanas -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">SEMANAS</div>
        <div class="secundary-cell w-50">
          <div v-if="matter && matter.use_matter_values && oldMatter">
            <span>{{ oldMatter.weeks }}</span>
          </div>
          <div v-else>
            <span v-if="matter">{{ matter.weeks }}</span>
          </div>
        </div>
      </div>

      <!-- Perfil de Egreso -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <span v-if="getEgressProfile">{{ getEgressProfile }}</span>
        </div>
      </div>

      <!-- Línea de Formación -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.formationline",
              false,
              "Línea De Formación"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getFormationLine">
            <div>
              {{ getFormationLine.name }}
            </div>
          </template>
        </div>
      </div>

      <!-- N° Docentes -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">N° DOCENTES</div>
        <div class="secundary-cell w-50">
          <span v-if="matter && matter.use_matter_values && oldMatter">
            {{
              oldMatter.suggested_teachers == null
                ? "0"
                : oldMatter.suggested_teachers
            }}
          </span>
          <span v-else>
            {{
              matter.suggested_teachers == null
                ? "0"
                : matter.suggested_teachers
            }}
          </span>
        </div>
      </div>

      <!-- N° Estudiantes -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">N° ESTUDIANTES</div>
        <div class="secundary-cell w-50">
          <span v-if="matter && matter.use_matter_values && oldMatter">
            {{
              oldMatter.suggested_students == null
                ? "0"
                : oldMatter.suggested_students
            }}
          </span>
          <span v-else>
            {{
              matter.suggested_students == null
                ? "0"
                : matter.suggested_students
            }}
          </span>
        </div>
      </div>

      <!-- Área de Formación -->
      <div v-if="!$hidesFormationArea(institution)" class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.formationarea",
              false,
              "Área De Formación"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getFormationAreas">
            <div>
              {{ getFormationAreas.name }}
            </div>
          </template>
        </div>
      </div>

      <!-- Tipo de Asignatura -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.mattertype",
              false,
              "Tipo De Asignatura"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getMatterType.length > 0">
            <span>
              {{ getMatterType.map((x) => x.name).join(", ") }}
            </span>
          </template>
          <template v-else>
            <div>N/A</div>
          </template>
        </div>
      </div>

      <!-- Régimen -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames("mesh.periodtype", false, "Régimen").toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <div v-if="getRegimen">
            {{ getRegimen.name }}
          </div>
        </div>
      </div>

      <!-- Estrategia Curricular (si está habilitado) -->
      <div
        v-if="institution && institution.show_matter_contribution"
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.mattercontribution",
              false,
              "ESTRATEGIA CURRICULAR"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getMatterContribution.length > 0">
            <span>
              {{ getMatterContribution.map((x) => x.name).join(", ") }}
            </span>
          </template>
          <template v-else>
            <div>N/A</div>
          </template>
        </div>
      </div>

      <!-- Modalidad de Asignatura -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.modality",
              false,
              "Modalidad de Asignatura"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getModalities.length > 0">
            <span>
              {{ getModalities.map((x) => x.name).join(", ") }}
            </span>
          </template>
          <template v-else>
            <div>N/A</div>
          </template>
        </div>
      </div>

      <!-- Ambiente de Aprendizaje (si está habilitado) -->
      <div
        v-if="institution && institution.show_study_environment_menu"
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "mesh.studyenvironment",
              false,
              "Ambiente de Aprendizaje"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell secundary-table1 w-50">
          <template v-if="getMatterStudyEnvironments.length > 0">
            <span>
              {{ getMatterStudyEnvironments.map((x) => x.name).join(", ") }}
            </span>
          </template>
          <template v-else>
            <div>N/A</div>
          </template>
        </div>
      </div>

      <!-- Total de Horas Pedagógicas (En Cronológicas) -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.total_pedagogical_hours_to_chronological",
              true,
              "Total de Horas Pedagógicas (En Cronológicas)"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50 px-0">
          <span v-if="profileType && totalPedagogical" class="border-hours">
            {{
              (totalPedagogical * (parseFloat(profileType.module_minutes) / 60))
                | Round
            }}
          </span>
          <!-- Horas pedagógicas detalle -->
          <div class="hours-detail-inline">
            <template
              v-if="
                matterHours.filter((x) => x.uses_module_minutes == true)
                  .length > 0
              "
            >
              <span
                v-for="item in matterHours.filter(
                  (x) => x.uses_module_minutes == true
                )"
                :key="item.id"
                :class="{
                  'hours-div': item.counts_towards_credits,
                  'hours-2-div': !item.counts_towards_credits,
                }"
              >
                <span
                  v-b-tooltip.v-secondary.noninteractive="
                    item.counts_towards_credits
                      ? `Se incluye en el ${$getVisibleNames(
                          'manual.total_pedagogical_hours',
                          true,
                          'Total de Horas Pedagógicas'
                        )} contables`
                      : `No se incluye en el ${$getVisibleNames(
                          'manual.total_pedagogical_hours',
                          true,
                          'Total de Horas Pedagógicas'
                        )} contables`
                  "
                >
                  {{ item.name }}:
                </span>
                <span v-b-tooltip.v-secondary.noninteractive="'Hora Pedagógica'"
                  >{{ item.hours }}
                </span>
                <span
                  v-if="
                    item.attendance_requirement != '' &&
                    item.attendance_requirement != null &&
                    item.attendance_requirement != 0
                  "
                  v-b-tooltip.v-secondary.noninteractive="
                    'Porcentaje de asistencia requerido'
                  "
                  >- {{ item.attendance_requirement }}%</span
                >
              </span>
            </template>
            <template v-else>
              <div class="hours-2-div">N/A</div>
            </template>
          </div>
        </div>
      </div>

      <!-- Total de Horas Cronológicas -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.total_chronological_hours",
              true,
              "Total de Horas Cronológicas"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50 px-0">
          <span class="border-hours">
            {{ totalChronological }}
          </span>
          <!-- Horas cronológicas detalle -->
          <div class="hours-detail-inline">
            <template
              v-if="
                matterHours.filter((x) => x.uses_module_minutes == false)
                  .length > 0
              "
            >
              <span
                v-for="item in matterHours.filter(
                  (x) => x.uses_module_minutes == false
                )"
                :key="item.id"
                :class="{
                  'hours-div': item.counts_towards_credits,
                  'hours-2-div': !item.counts_towards_credits,
                }"
              >
                <span
                  v-b-tooltip.v-secondary.noninteractive="
                    item.counts_towards_credits
                      ? `Se incluye en el ${$getVisibleNames(
                          'manual.total_chronological_hours',
                          true,
                          'Total de Horas Cronológicas'
                        )} contables`
                      : `No se incluye en el ${$getVisibleNames(
                          'manual.total_chronological_hours',
                          true,
                          'Total de Horas Cronológicas'
                        )} contables`
                  "
                >
                  {{ item.name }}:
                </span>
                <span
                  v-b-tooltip.v-secondary.noninteractive="'Hora Cronológica'"
                  >{{ item.hours }}
                </span>
                <span
                  v-if="
                    item.attendance_requirement != '' &&
                    item.attendance_requirement != null &&
                    item.attendance_requirement != 0
                  "
                  v-b-tooltip.v-secondary.noninteractive="
                    'Porcentaje de asistencia requerido'
                  "
                  >- {{ item.attendance_requirement }}%</span
                >
              </span>
            </template>
            <template v-else>
              <div class="hours-2-div">N/A</div>
            </template>
          </div>
        </div>
      </div>

      <!-- Total de Horas Cronológicas (Total) -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">TOTAL DE HORAS CRONOLÓGICAS</div>
        <div class="secundary-cell w-50">
          {{ totalHours | Round }}
        </div>
      </div>

      <!-- Créditos SCT Totales -->
      <div class="table-cell d-flex">
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.credits",
              true,
              "Créditos SCT Totales"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <div v-if="matter && matter.use_matter_values && oldMatter">
            <span>{{ oldMatter.credits }}</span>
          </div>
          <div v-else>
            <span v-if="matter">
              {{ matter.credits }}
            </span>
          </div>
        </div>
      </div>

      <!-- Créditos Institucionales (si es UNAB) -->
      <div
        v-if="$hasInstitutionalCredits(institution)"
        class="table-cell d-flex"
      >
        <div class="primary-cell w-50">
          {{
            $getVisibleNames(
              "manual.institutional_credits",
              true,
              "Créditos Institucionales"
            ).toUpperCase()
          }}
        </div>
        <div class="secundary-cell w-50">
          <div v-if="matter && matter.use_matter_values && oldMatter">
            <span>{{ oldMatter.institutional_credits }}</span>
          </div>
          <div v-else>
            <span v-if="matter">
              {{ matter.institutional_credits }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import {
  toast,
  fetchMissingEgressProfileMattersAndMatters,
} from "@/utils/utils";

export default {
  name: "MatterPresentation",
  props: {
    Matter: {
      type: Object,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      matter: this.Matter,
    };
  },
  computed: {
    ...mapGetters({
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      time_allocations: names.TIME_ALLOCATIONS,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
      matters: names.MATTERS,
      user: "getUser",
      formationAreas: names.FORMATION_AREAS,
      formationLines: names.FORMATION_LINES,
      matterTypes: names.MATTER_TYPES,
      faculties: names.FACULTIES,
      matterContributions: names.MATTER_CONTRIBUTIONS,
      modalities: names.MODALITIES,
      egress_profiles: names.EGRESS_PROFILES,
      profile_types: names.PROFILE_TYPES,
      studyEnvironments: names.STUDY_ENVIRONMENTS,
      regimes: names.REGIMES,
      career: names.CAREERS,
      institution: "getInstitution",
    }),
    // Added computed properties for grid layout
    numberTableHeader() {
      let column = 11;
      // Base columns: Código, Nombre, Semanas, etc.
      if (this.matter) column += 5; // Additional fields when matter exists
      if (this.institution && this.institution.show_study_environment_menu)
        column += 1; // Ambiente de Aprendizaje
      if (this.$hasInstitutionalCredits(this.institution))
        column += 1; // Créditos Institucionales
      if (this.institution && this.institution.show_matter_contribution)
        column += 1; // Estrategia Curricular
      return column;
    },
    isPairNumberTableHeader() {
      return this.numberTableHeader % 2 == 0;
    },
    careerFilter() {
      return this.career.find((x) =>
        x.egress_profiles.includes(this.matter.egress_profile)
      );
    },
    faculty() {
      if (!this.careerFilter) return null;
      return this.faculties.find((x) => x.id == this.careerFilter.faculty);
    },
    egressProfile() {
      if (!this.matter.egress_profile) return [];
      return this.egress_profiles.find(
        (x) => x.id == this.matter.egress_profile
      );
    },
    matterHours() {
      let list = [];
      this.time_allocations.forEach((element) => {
        if (this.Matter.use_matter_values) {
          const matter_hour = this.matter_time_allocations.find(
            (x) =>
              x.matter == this.Matter.matter && x.time_allocation == element.id
          );
          if (matter_hour && this.oldMatter)
            list.push({
              id: matter_hour.id,
              time_allocation: matter_hour.time_allocation,
              name: element.name,
              order: element.order,
              uses_module_minutes: element.uses_module_minutes,
              matter: matter_hour.matter,
              counts_towards_credits: matter_hour.counts_towards_credits,
              attendance_requirement: matter_hour.attendance_requirement,
              hours: matter_hour.hours,
              tem_hours:
                parseFloat(this.oldMatter.weeks) > 0
                  ? Math.round(
                      parseFloat(matter_hour.hours) /
                        parseFloat(this.oldMatter.weeks)
                    )
                  : 0,
            });
        } else {
          const matter_hour = this.ep_matter_time_allocations.find(
            (x) =>
              x.egress_profile_matter == this.Matter.id &&
              x.time_allocation == element.id
          );
          if (matter_hour)
            list.push({
              id: matter_hour.id,
              time_allocation: matter_hour.time_allocation,
              name: element.name,
              order: element.order,
              uses_module_minutes: element.uses_module_minutes,
              egress_profile_matter: matter_hour.egress_profile_matter,
              counts_towards_credits: matter_hour.counts_towards_credits,
              attendance_requirement: matter_hour.attendance_requirement,
              hours: matter_hour.hours,
              tem_hours:
                parseFloat(this.Matter.weeks) > 0
                  ? Math.round(
                      parseFloat(matter_hour.hours) /
                        parseFloat(this.Matter.weeks)
                    )
                  : 0,
            });
        }
      });
      return list;
    },
    getEgressProfile() {
      const instance = this.egress_profiles.find(
        (x) => x.id == this.matter.egress_profile
      );
      let arr = [];
      if (instance) {
        if (instance.code.trim() != "") arr.push(instance.code);
        if (instance.init_date) arr.push(instance.init_date);
        if (instance.professional_title.trim() != "")
          arr.push(instance.professional_title);
        return arr.join(" - ");
      } else return null;
    },
    profileType() {
      if (!this.egressProfile) return [];
      return this.profile_types.find(
        (x) => x.id == this.egressProfile.egress_profile_type
      );
    },
    oldMatter() {
      if (!this.matter) return null;
      return this.matters.find((x) => x.id == this.matter.matter);
    },
    prerequisites() {
      let names = [];
      if (!this.matter) return names;
      this.matter.prerequisites.forEach((element) => {
        let egress_profile_matter = this.egress_profiles_matters.find(
          (x) => x.id == element
        );
        if (egress_profile_matter) {
          let instance = this.matters.find(
            (x) => x.id == egress_profile_matter.matter
          );
          if (instance) names.push(instance.name);
        }
      });
      return names;
    },
    getFormationLine() {
      if (!this.matter) return [];
      const matter_formation_line = this.formationLines.find(
        (x) => this.matter.formation_line == x.id
      );
      return matter_formation_line ? matter_formation_line : { name: "N/A" };
    },
    getMatterType() {
      if (!this.matter) return [];
      const get_matter_types = this.matterTypes.filter((x) =>
        this.matter.matter_types.includes(x.id)
      );
      return get_matter_types ? get_matter_types : [];
    },
    getMatterContribution() {
      if (!this.matter) return [];
      const get_matter_contributions = this.matterContributions.filter((x) =>
        this.matter.matter_contributions.includes(x.id)
      );
      return get_matter_contributions ? get_matter_contributions : [];
    },
    getFormationAreas() {
      if (!this.matter) return [];
      const get_formation_area = this.formationAreas.find(
        (x) => x.id == this.matter.formation_area
      );
      return get_formation_area ? get_formation_area : { name: "N/A" };
    },
    getModalities() {
      if (!this.matter || !this.oldMatter) return [];
      let modalities_ids = [];
      if (this.matter.use_matter_values)
        modalities_ids = this.oldMatter.modalities;
      else modalities_ids = this.matter.modalities;
      return this.modalities.filter((x) => modalities_ids.includes(x.id));
    },
    getMatterStudyEnvironments() {
      if (!this.matter || !this.oldMatter) return [];
      let study_environments_ids = [];
      if (this.matter.use_matter_values)
        study_environments_ids = this.oldMatter.study_environments;
      else study_environments_ids = this.matter.study_environments;
      return this.studyEnvironments.filter((x) =>
        study_environments_ids.includes(x.id)
      );
    },
    getRegimen() {
      if (!this.matter) return [];
      const get_regime = this.regimes.find((x) => x.id == this.matter.regime);
      return get_regime ? get_regime : { name: "N/A" };
    },
    totalPedagogical() {
      let count = 0;
      this.matterHours
        .filter((x) => x.uses_module_minutes == true)
        .forEach((element) => {
          if (
            element.counts_towards_credits &&
            element.hours &&
            element.hours >= 0
          ) {
            count += parseFloat(element.hours);
          }
        });
      return count;
    },
    totalChronological() {
      let count = 0;
      this.matterHours
        .filter((x) => x.uses_module_minutes == false)
        .forEach((element) => {
          if (
            element.counts_towards_credits &&
            element.hours &&
            element.hours >= 0
          ) {
            count += parseFloat(element.hours);
          }
        });
      return count;
    },
    totalHours() {
      if (!this.profileType) return 0;
      const total_hours =
        this.totalPedagogical * (this.profileType.module_minutes / 60) +
        this.totalChronological;
      return total_hours ? total_hours : 0;
    },
  },
  methods: {
    // matter.prerequisites son ids de egress-profile-matter, que pueden
    // pertenecer a otro perfil de egreso (transversales).
    fetchPrerequisites() {
      fetchMissingEgressProfileMattersAndMatters(this.matter.prerequisites);
    },
    getMatterName(matter_id) {
      const matter = this.matters.find((x) => x.id == matter_id);
      return matter ? matter.name : "";
    },
    patchMatter(item) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const payload = {
          egress_profile_matter_id: this.matter.id,
          item: item,
        };
        this.$store
          .dispatch(names.PATCH_EGRESS_PROFILE_MATTER, payload)
          .then(() => {
            toast(
              this.$getVisibleNames(
                "mesh.egressprofilematter",
                false,
                "Asignatura"
              ) + " actualizada."
            );
          });
      }, 3000);
    },
  },
  watch: {
    "matter.assistantship_hours_assistance": function () {
      this.patchMatter({
        assistantship_hours_assistance:
          this.matter.assistantship_hours_assistance,
      });
    },
    "matter.theoric_hours_assistance": function () {
      this.patchMatter({
        theoric_hours_assistance: this.matter.theoric_hours_assistance,
      });
    },
    "matter.lab_hours_assistance": function () {
      this.patchMatter({
        lab_hours_assistance: this.matter.lab_hours_assistance,
      });
    },
    "matter.ground_hours_assistance": function () {
      this.patchMatter({
        ground_hours_assistance: this.matter.ground_hours_assistance,
      });
    },
  },
  mounted() {
    if (!isNaN(this.Matter.id)) {
      this.$store.dispatch(names.FETCH_EP_MATTER_TIME_ALLOCATIONS, {
        egress_profile_matter_id: this.Matter.id,
      });
      this.$store.dispatch(names.FETCH_MATTER_TIME_ALLOCATIONS, {
        matter_id: this.Matter.matter,
      });
    }
  },
  created() {
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.matter.egress_profile)
      .then((response) => {
        this.$store
          .dispatch(names.FETCH_CAREER, response.career)
          .then((career) => {
            this.$store.dispatch(names.FETCH_FACULTY, career.faculty);
          });
      });
    this.fetchPrerequisites();
    this.$store.dispatch(names.FETCH_PROFILE_TYPES);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
    this.$store.dispatch(names.FETCH_FORMATION_LINES);
    this.$store.dispatch(names.FETCH_FORMATION_AREAS);
    this.$store.dispatch(names.FETCH_MATTER_CONTRIBUTIONS);
    this.$store.dispatch(names.FETCH_MATTER_TYPES);
    this.$store.dispatch(names.FETCH_MODALITIES);
  },
};
</script>

<style scoped>
.border-hours {
  border-bottom: 1px solid var(--kl-table-border);
  width: 100%;
}
.title-presentation {
  display: flex;
  margin-bottom: 20px;
  margin-top: 20px;
  font-weight: var(--kl-fw-bold);
  color: var(--kl-text-heading);
}

.name-matter,
.code-matter {
  font-weight: var(--kl-fw-bold);
}

.name-matter {
  color: var(--kl-text-on-primary);
  background-color: var(--kl-fourth-color) !important;
  height: 100%;
}

.table-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  font-size: 10pt;
  margin-bottom: 20px;
  gap: 0px;
  /* Borde único: el contenedor pinta arriba/izquierda y cada celda pinta
     derecha/abajo, así no se duplican las líneas. Borde estándar (--kl-table-border). */
  border-top: 1px solid var(--kl-table-border);
  border-left: 1px solid var(--kl-table-border);
  border-radius: var(--kl-radius-md);
  overflow: hidden;
}

.table-cell {
  border-right: 1px solid var(--kl-table-border);
  border-bottom: 1px solid var(--kl-table-border);
}

.primary-cell {
  height: 100%;
  display: flex;
  padding-left: 1em;
  padding-right: 1em;
  align-items: center;
  /* Columna de etiquetas (header): azul medio + texto blanco. */
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary);
  font-weight: var(--kl-fw-bold);
  text-align: start;
}

.secundary-cell {
  padding: 4px;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.secundary-table1 {
  justify-content: center;
}

.prerequisites-p {
  vertical-align: middle;
  margin: 7px 10px;
}

.hours-detail-inline {
  margin-top: 8px;
  font-size: var(--kl-fs-caption);
}

.hours-div {
  background-color: var(--kl-color-primary);
  color: var(--kl-text-on-primary);
  max-width: fit-content;
  line-height: 1;
  padding: var(--kl-chip-padding);
  border-radius: var(--kl-radius-pill);
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  margin: 0.1em;
  display: inline-block;
}

.hours-2-div {
  background-color: var(--kl-color-secondary);
  color: var(--kl-text-on-primary);
  max-width: fit-content;
  line-height: 1;
  padding: var(--kl-chip-padding);
  border-radius: var(--kl-radius-pill);
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  margin: 0.1em;
  display: inline-block;
}

@media (max-width: 1100px) {
  .table-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 750px) {
  .table-container {
    grid-template-columns: repeat(1, 1fr);
  }
  .title-presentation {
    flex-direction: column;
    align-items: center;
  }

  .school-title,
  .program-title {
    width: 100%;
    text-align: center;
  }
  .school-title {
    margin-bottom: 1rem;
  }
}

@media print {
  .table-container {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
</style>